import { CLANSTARS_REWARD_STATUSES } from '~/constants';
import { iHavePermission, PERMISSIONS } from '~/roles';
import { patrolsAccountSelector } from '~/store/selectors//patrolsSelectors';
import { isClanHubEnabledSelector } from '~/store/selectors//settingsSelector';
import { clanStarsSelector } from '~/store/selectors/clanStarsSelectors';
import { clanTasksSelector } from '~/store/selectors/clanTasksSelectors';
import { clanWarsSelector } from '~/store/selectors/clanWarsSelectors';
import { currentAccountSelector } from '~/store/selectors/currentAccountSelector';
import { createAppSelector } from '~/store/utils/createSelector';

export const navigationSelector = createAppSelector(
  [
    currentAccountSelector,
    clanTasksSelector,
    clanWarsSelector,
    clanStarsSelector,
    patrolsAccountSelector,
    isClanHubEnabledSelector,
  ],
  (currentAccount, clanTasks, clanWars, clanStars, patrolsAccount, isClanHubEnabled) => {
    const clanTasksUnclaimedAmount = clanTasks.tasks.filter((task) => task.isFinished && !task.isClaimed).length;
    const clanStarsNewRewards = clanStars.accountRewards.filter((reward) => {
      if (!reward.status) {
        return false;
      }

      return [CLANSTARS_REWARD_STATUSES.NEW, CLANSTARS_REWARD_STATUSES.FAILED].includes(reward.status);
    }).length;

    const canClaimRewards = iHavePermission(PERMISSIONS.CHANGE_SETTINGS, currentAccount);

    return {
      canClaimRewards,
      clanStarsNewRewards,
      clanTasks: clanTasks.tasks,
      clanTasksUnclaimedAmount,
      clanWarsCurrentStage: clanWars.stages.currentStage,
      clanWarsIsFromPort: clanWars.isFromPort,
      clanWarsIsParticipating: clanWars.commonInfo?.clan?.settings?.isParticipating || false,
      clanWarsSetingsStages: clanWars.warSettings.stages,
      currentAccount,
      isClanHubEnabled,
      patrolsAccount,
    };
  },
);

export type NavigationContext = ReturnType<typeof navigationSelector>;
